import { makeStyles } from '@material-ui/core/styles';
import Configuration from '../../configuration';

export const FORM_FIELDS_COLOR = '#DEDEDE';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    backgroundImage: `url(${Configuration.backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: FORM_FIELDS_COLOR,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 2rem',
    minHeight: '75vh',
    borderRadius: '24px',
    border: '3px solid #2E3546',
    background: 'rgba(0, 0, 0, 0.2)',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: 'transparent',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    backgroundColor: '#024C7A',
    margin: theme.spacing(3, 0, 3),
    padding: '.75rem .5rem',
    width: '100%',
    alignSelf: 'center',
    borderRadius: '24px',
    '&:hover': {
      backgroundColor: '#024C7A',
      opacity: '.9',
    },
  },
  img_logo: {
    marginBottom: 13,
    height: 90,
  },
  link: {
    color: 'inherit !important',
  },
  // input
  input: {
    color: FORM_FIELDS_COLOR,
  },
  inputLabel: {
    color: FORM_FIELDS_COLOR,
    '&.Mui-focused': {
      color: FORM_FIELDS_COLOR,
    },
  },
  inputLabelFocus: {},
  inputIcon: {
    color: FORM_FIELDS_COLOR,
  },
  notchedOutline: {
    borderWidth: '1px !important',
    borderColor: `${FORM_FIELDS_COLOR} !important`,
    color: `${FORM_FIELDS_COLOR} !important`,
    borderRadius: '25px',
  },
  notchedOutlineFocus: {
    borderWidth: '1px',
    borderColor: `${FORM_FIELDS_COLOR} !important`,
  },
}));

export default useStyles;
